var map = {
	"./base.js": "1r4h",
	"./index.js": "KCWE",
	"./myCards.js": "xlCy",
	"./myExam.js": "xdpt",
	"./myExamSxlx.js": "Em7Q",
	"./sys.js": "7D1K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nx15";


//////////////////
// WEBPACK FOOTER
// ./src/request/api \.js$
// module id = nx15
// module chunks = 21